/* ==========================================================================
   13th Anniversary BOGO landing page
   --------------------------------------------------------------------------
   Three behaviours, none of which own any copy:

     1. countdowns (bar + hero), both driven by the one end date the bar
        section writes to [data-anv-config]
     2. the "offer ended" state: .anv-ended on <html> hides every CTA and
        countdown and shows each section's ended line (CSS does the hiding).
        The bar section also sets the class inline before paint, so a visitor
        after the deadline never sees a CTA flash
     3. builder links: every [data-anv-builder] link (bar, CTAs, model cards,
        mobile sticky bar) points at the one builder URL the bar section
        writes to [data-anv-config]. Model cards add ?bike=<handle> from
        data-anv-bike. Until this runs the links fall back to #anv-models

   There is no add to cart on this page: the pair is built in the BOGO
   builder, and the discount is a Shopify automatic discount. Nothing here
   touches prices.

   Loaded with defer by each section that needs it; the guard below means it
   only ever runs once.
   ========================================================================== */

(function () {
  "use strict";

  if (window.anvLandingInitialised) {
    return;
  }
  window.anvLandingInitialised = true;

  var root = document.documentElement;
  var countdownTimer = null;

  function pad(n) {
    return n < 10 ? "0" + n : "" + n;
  }

  /* --- 1 + 2. Countdowns and ended state --------------------------------- */

  function initCountdowns() {
    if (countdownTimer) {
      clearInterval(countdownTimer);
      countdownTimer = null;
    }

    var config = document.querySelector("[data-anv-config]");
    var end = config ? Date.parse(config.getAttribute("data-anv-end") || "") : NaN;

    var boards = document.querySelectorAll("[data-anv-cd]");
    var inlines = document.querySelectorAll("[data-anv-inline]");

    /* No bar section, or a date that does not parse: hide the countdowns
       rather than count down to nothing. CTAs stay live. */
    if (isNaN(end)) {
      Array.prototype.forEach.call(boards, function (el) {
        el.hidden = true;
      });
      Array.prototype.forEach.call(inlines, function (el) {
        el.hidden = true;
      });
      return;
    }

    function tick() {
      var ms = Math.max(0, end - Date.now());
      var d = Math.floor(ms / 864e5);
      var h = Math.floor((ms % 864e5) / 36e5);
      var m = Math.floor((ms % 36e5) / 6e4);
      var s = Math.floor((ms % 6e4) / 1e3);

      Array.prototype.forEach.call(boards, function (cd) {
        var parts = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };
        Object.keys(parts).forEach(function (key) {
          var el = cd.querySelector("[data-" + key + "]");
          if (el && el.textContent !== parts[key]) {
            el.textContent = parts[key];
          }
        });
      });

      Array.prototype.forEach.call(inlines, function (el) {
        var suffix = el.getAttribute("data-anv-left") || "left";
        var ended = el.getAttribute("data-anv-ended-text") || "Offer ended";
        el.textContent = ms > 0 ? d + "d " + pad(h) + "h " + pad(m) + "m " + suffix : ended;
      });

      /* Toggled rather than only added, so moving the date forward in the
         theme editor brings the CTAs back. */
      root.classList.toggle("anv-ended", ms <= 0);
      if (ms <= 0 && countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    }

    tick();
    if (!root.classList.contains("anv-ended")) {
      countdownTimer = setInterval(tick, 1000);
    }
  }

  /* --- 3. Builder links ------------------------------------------------- */

  function builderHref(base, bike) {
    if (!bike) {
      return base;
    }
    var hashAt = base.indexOf("#");
    var hash = hashAt > -1 ? base.slice(hashAt) : "";
    var path = hashAt > -1 ? base.slice(0, hashAt) : base;
    return path + (path.indexOf("?") > -1 ? "&" : "?") + "bike=" + encodeURIComponent(bike) + hash;
  }

  function initBuilderLinks() {
    var config = document.querySelector("[data-anv-config]");
    var base = config ? (config.getAttribute("data-anv-builder") || "").trim() : "";

    /* No builder URL set: leave the #anv-models fallback in place. */
    if (!base) {
      return;
    }

    Array.prototype.forEach.call(document.querySelectorAll("[data-anv-builder]"), function (link) {
      link.setAttribute("href", builderHref(base, link.getAttribute("data-anv-bike")));
    });
  }

  function init() {
    initCountdowns();
    initBuilderLinks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Theme editor: sections re-render in place, so re-read the end date and
     re-point the links a re-rendered section brings back. */
  document.addEventListener("shopify:section:load", init);
})();
